import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function NHLEParishFilter({ setFilter, removeFilter, facets, filters }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="parish"
      filters={filters}
      id="parish"
      label="Parish (civil / non-civil)"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(props => {
  return {
    setFilter: props.setFilter,
    removeFilter: props.removeFilter,
    facets: props.facets,
    filters: props.filters,
  };
})(NHLEParishFilter);
